import { render, staticRenderFns } from "./NotificationIconButton.vue?vue&type=template&id=dfea6884&scoped=true"
import script from "./NotificationIconButton.vue?vue&type=script&lang=ts"
export * from "./NotificationIconButton.vue?vue&type=script&lang=ts"
import style0 from "./NotificationIconButton.vue?vue&type=style&index=0&id=dfea6884&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfea6884",
  null
  
)

export default component.exports